import { TicketTypeState } from "@/domain/ticket-selection";

export class TicketTypeStateProvider {

    /**
     * whatItDoes
     * returns urlEncoded TicketType for add to cart url query string
     */
    public static provideEncodedUriFragmentFor(ticketType: TicketTypeState, priceLevelId: number): string {
        return encodeURIComponent(`cat[${priceLevelId}_${ticketType.priceId}]`) + `=${ticketType.amount}`;
    }

}
